import { css } from 'styled-components';

export const subTitleOverrideStyle = css`
  ${({ theme }) => {
    const { cardFields } = theme.hcp || {};
    if (cardFields) {
      return css`
        color: ${cardFields?.subTitle?.color};
      `;
    }
  }}
`;
